import {
  ButtonGroup,
  SelectOption,
  StyledText,
} from '@leasequery/lq.react-component-library';
import React, { useCallback, useEffect, useRef } from 'react';
import { BUTTON_GROUP_OPTIONS } from '../../../util/constants';
import * as Styled from './styled';
import { Icon } from '../../../components';
import type { SplitByAllocationSwitchState, SplitByDimensionOrAllocationState } from './SplitByDimensionOrAllocation';
import { DisplayBy } from '../../../constants/DisplayBy';
import SplitDisplayDimensionBySelector from './SplitDisplayDimensionBySelector';

export interface SplitByDimensionState extends SplitByAllocationSwitchState {
  displayDimensionBy?: DisplayBy | null;
}

interface SplitByDimensionProps {
  onChange: (updatedValue: SplitByDimensionOrAllocationState) => void;
  splitState: SplitByDimensionOrAllocationState;
}


function SplitByDimension({
  onChange,
  splitState = {},
}: Readonly<SplitByDimensionProps>): JSX.Element {

  const {
    splitByAllocationSwitchValue = BUTTON_GROUP_OPTIONS[0],
    displayDimensionBy,
  } = splitState;

  const splitStateRef = useRef(splitState);
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    splitStateRef.current = splitState;
    onChangeRef.current = onChange;
  }, [splitState, onChange]);

  useEffect(() => {
    if (displayDimensionBy === null && splitByAllocationSwitchValue.value) {
      onChangeRef.current?.({ ...splitStateRef.current, displayDimensionBy: DisplayBy.Name });
    }
  }, [displayDimensionBy, splitByAllocationSwitchValue.value]);

  const splitByAllocationSwitchChangeHandler = useCallback(
    (_, option: SelectOption<boolean>) => {
      onChange({ ...splitState, splitByAllocationSwitchValue: option });
    },
    [onChange, splitState],
  );
  const displayDimensionByInputChangeHandler = useCallback(
    (value: DisplayBy) => {
      onChange({ ...splitState, displayDimensionBy: value });
    },
    [onChange, splitState],
  );

  return (
    <Styled.SplitByDimension>
      <div>
        <Icon name="split" />
      </div>
      <div className="splitSection">
        <StyledText as="div" fontWeight="medium">
          Split by Allocation
        </StyledText>
        <StyledText as="div" className="splitDescription">
          Generates an additional sheet to your Excel export that splits each lease into multiple rows based on allocation percentages. Financial figures are weighted accordingly.
        </StyledText>
        {splitByAllocationSwitchValue.value && (
            <div className="splitByDimensionBySection">
                <SplitDisplayDimensionBySelector
                  value={displayDimensionBy}
                  onChange={displayDimensionByInputChangeHandler}
                />
            </div>
        )}
      </div>
      <div className="splitButtonSwitch">
        <ButtonGroup
          options={BUTTON_GROUP_OPTIONS}
          selectedOption={splitByAllocationSwitchValue}
          onClick={splitByAllocationSwitchChangeHandler}
          name="split-switch"
        />
      </div>
    </Styled.SplitByDimension>
  );
}

export default SplitByDimension;
